/**
 * Customer Segment Distribution Chart
 * Beautiful pie chart showing customer segments
 */

import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { CustomerSegment, SEGMENT_COLORS, SEGMENT_LABELS } from '../../types/analytics';

interface CustomerSegmentChartProps {
  data: Record<CustomerSegment, number>;
}

export function CustomerSegmentChart({ data }: CustomerSegmentChartProps) {
  // Transform data for recharts
  const chartData = Object.entries(data)
    .filter(([_, value]) => value > 0)
    .map(([segment, count]) => ({
      name: SEGMENT_LABELS[segment as CustomerSegment],
      value: count,
      segment: segment as CustomerSegment,
    }))
    .sort((a, b) => b.value - a.value);

  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500 dark:text-slate-400">
        Nessun dato disponibile
      </div>
    );
  }

  return (
    <div className="w-full h-80">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry) => (
              <Cell key={entry.segment} fill={SEGMENT_COLORS[entry.segment]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value: number) => [`${value} clienti`, 'Totale']}
          />
          <Legend
            verticalAlign="bottom"
            height={36}
            formatter={(value, entry: any) => `${value} (${entry.payload.value})`}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
